// extracted by mini-css-extract-plugin
module.exports = {"img":"Logo-img-fbbFh"};